<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    offset="8"
    data-html2canvas-ignore
    content-class="nav-menu"
    @update:model-value="$event ? showAccountSwitch = false : undefined"
  >
    <template #activator="{ props }">
      <button 
        v-bind="props"
        class="position-relative "
      >
        <v-badge>
          <ProfileImage  
            :user="$auth.user"
            :size="$vuetify.display.mdAndUp ? 64 : 32"
            :bordered="$vuetify.display.mdAndUp"
            border-width="2"
            :style="profileImageStyles"
            class="avatar"
          />
  
          <template #badge>
            <StopImpersonatingButton
              class="profile-image-stop-impersonating"
              :style="impersonationBtnStyles"
            />
          </template>
        </v-badge>

        <v-icon
          ref="menuArrow"
          class="menu-arrow"
          size="36"
          :style="menuArrowStyles"
          v-if="$vuetify.display.mdAndUp"
        >
          arrow_drop_down
        </v-icon>
      </button>
    </template>

    <v-card
      v-if="showAccountSwitch"
      class="pa-2 pa-md-4"
    >
      <AccountSwitcher
        @back="showAccountSwitch = false"
        @success="menuOpen = false"
      />
    </v-card>

    <v-list
      v-else
      class="text-uppercase"
    >
      <v-list-item
        @click="showAccountSwitch = true"
        v-if="$auth.user?.account?.users_count && $auth.user?.account?.users_count > 1"
      >
        <v-icon class="mr-4">
          swap_horiz
        </v-icon>
        Switch profile
      </v-list-item>

      <v-list-item 
        @click="logout"
      >
        <v-icon class="mr-4">
          logout
        </v-icon>
        Log out
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import ProfileImage from "@/components/ProfileImage.vue"
import StopImpersonatingButton from "@/components/StopImpersonatingButton.vue"
import AccountSwitcher from "@/components/AccountSwitcher.vue"

export default defineComponent({
  components: {
    ProfileImage,
    StopImpersonatingButton,
    AccountSwitcher,
  },
  props: {
    scrollProgress: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      menuOpen: false,
      showAccountSwitch: false
    }
  },
  mounted() {
    const userId = parseInt(this.$route.query['id'] as string) || null
    
    if (userId && userId !== this.$auth.user?.id) {
      this.menuOpen = true
      this.showAccountSwitch = true
    }
  },
  computed: {
    profileImageStyles() {
      if (!this.scrollProgress || !this.$vuetify.display.mdAndUp) return {}
      const scale = 2 - 2 * this.scrollProgress
      return {
        transform: `scale(${scale > 1 ? scale : 1})`,
      }
    },
    menuArrowStyles() {
      if (!this.scrollProgress || !this.$vuetify.display.mdAndUp) return {}

      const xPos = 6 - 12 * this.scrollProgress,
            yPos = -6 + 22 * this.scrollProgress
      return {
        right: `${xPos}px`,
        bottom: `${yPos}px`,
      }
    },
    impersonationBtnStyles() {
      if (!this.scrollProgress || !this.$vuetify.display.mdAndUp) return {}

      return {
        opacity: 1 - (this.scrollProgress > 0 ? 1 : 0),
      }
    },
    
  },
  methods: {
    async logout() {
      await this.$auth.logout()
      await this.$router.push(this.$routeTo(this.ROUTES.LOGIN))
    }
  }
})
</script>

<style lang="scss" scoped>


.avatar {
  transform-origin: right bottom;
  @media #{map-get(settings.$display-breakpoints, 'md-and-up')} {
    transform: scale(2);
    margin-right: 1.5rem;
  }
}

.menu-arrow {
  position: absolute;
  bottom: -0.375rem;
  right: 0.375rem;
  z-index: 5;
  transition: none;
}

</style>